import React, { useCallback, useState } from 'react';

import AppButton from '@/components/controls/AppButton';
import VerifyMyCardModal from '@/modules/core/components/Dashboard/components/BannersList/CompleteBanner/components/VerifyMyCardModal';
import SuccessActivatedModal from '@/modules/core/components/Dashboard/components/BannersList/CompleteBanner/components/VerifyMyCardModal/components/SuccessActivatedModal';
import { CardActivationVariants } from '@/modules/core/components/Dashboard/components/BannersList/CompleteBanner/components/VerifyMyCardModal/VerifyMyCardModal.constants';
import VerifyEmployeeButton from '@/modules/core/components/Dashboard/components/BannersList/CompleteBanner/VerifyEmployeeButton';

import { useGetVerificationEmail, useHandleRefetchCards } from './LimitedAccessVerification/hooks';
import { useIsLimitedAccess } from './hooks';
import LimitedAccessVerification from './LimitedAccessVerification';
type ButtonType = React.ComponentProps<typeof AppButton>;
interface Props extends Partial<ButtonType> {
  onSetVisible?: (value: boolean) => void;
  isBannerMode?: boolean;
}

const LimitedAccessVerificationButton: React.FC<Props> = ({ onSetVisible, isBannerMode, ...rest }) => {
  const [verificationVisible, setVerificationVisible] = useState(false);
  const [verificationCardVisible, setVerificationCardVisible] = useState(false);
  const isLimitedAccess = useIsLimitedAccess();
  const [isSuccessCardModalVisible, setSuccessCardModalVisible] = useState(false);
  const [isSuccessEmailModalVisible, setSuccessEmailModalVisible] = useState(false);
  const verificationEmail = useGetVerificationEmail();
  const handleOpenModal = useCallback(() => {
    if (verificationEmail) {
      setVerificationVisible(true);
    } else {
      setVerificationCardVisible(true);
    }
    if (onSetVisible) {
      onSetVisible(false);
    }
  }, [onSetVisible, verificationEmail]);

  const handleRefetch = useHandleRefetchCards();
  const handleCloseSuccess = () => {
    handleRefetch();
    setSuccessCardModalVisible(false);
    setSuccessEmailModalVisible(false);
  };
  if (!isLimitedAccess) {
    return null;
  }

  return (
    <>
      {isSuccessCardModalVisible && (
        <SuccessActivatedModal
          onSetVisible={handleCloseSuccess}
          isActivationSuccess={CardActivationVariants.ACTIVATED}
        />
      )}
      {isSuccessEmailModalVisible && (
        <SuccessActivatedModal
          isEmailMethod
          onSetVisible={handleCloseSuccess}
          isActivationSuccess={CardActivationVariants.ACTIVATED}
        />
      )}
      {verificationVisible && (
        <LimitedAccessVerification
          onSuccess={() => setSuccessEmailModalVisible(true)}
          visible={verificationVisible}
          onSetVisible={setVerificationVisible}
          onOpenCardVerification={() => setVerificationCardVisible(true)}
        />
      )}
      {verificationCardVisible && (
        <VerifyMyCardModal
          onSuccess={() => setSuccessCardModalVisible(true)}
          onSetVisible={setVerificationCardVisible}
          refreshCardList={handleRefetch}
        />
      )}

      <VerifyEmployeeButton isBannerMode={isBannerMode} size="L" fill onClick={handleOpenModal} {...rest} />
    </>
  );
};

export default LimitedAccessVerificationButton;
